<div class="view-main">
    <app-header></app-header>
    <div class="view-content grid-y grid-padding-x">
        <router-outlet></router-outlet>
    </div>
</div>
